/**
 * Modal ids
 */
export default {
    LINK_VIEW_MODAL: 'link-view-modal',
    PRINT_MODAL: 'print-modal',
};
